export default __webpack_public_path__ + "static/media/referral-ilustration.ee1e6d7d.svg";